import { ReactElement, ReactNode } from "react";
import { pluralize } from "@sellar-io/common";
import { Link } from "react-router";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";
import { LAYOUT_GROUPING } from "../../constants/routes";
import { Button, Card, H5, Icon } from "@sellar-io/components";
import { useProductUngrouped } from "../../hooks/api/v2/product/useUngroupedProducts";

export function GroupProductsContainer({
  title,
  description,
  children,
  onClickClose,
}: {
  title: string;
  description: string;
  children?: ReactNode;
  onClickClose: () => void;
}) {
  return (
    <Card className="gap-2 border border-zinc-300 bg-white bg-zinc-50 p-4">
      <div className="flex flex-row justify-between">
        <div className={"mr-4"}>
          <Icon icon="VIEW_DASHBOARD_OUTLINE" />
        </div>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col">
            <H5>{title}</H5>
            <p>{description}</p>
          </div>
          {children}
        </div>
        <div>
          <Icon
            size={1}
            icon={"CLOSE"}
            className="cursor-pointer"
            onClick={() => onClickClose()}
          />
        </div>
      </div>
    </Card>
  );
}
export function GroupProductsBanner({
  onClickClose,
}: {
  onClickClose: () => void;
}): ReactElement | null {
  const { business } = useSellarCurrentBusiness();
  const { data, isLoading, isPending } = useProductUngrouped();

  if (business?.Retailer || isLoading || isPending || !data?.length) {
    return null;
  }

  return (
    <GroupProductsContainer
      title={`You have ${data.length} ${pluralize("product", data.length)} ungrouped`}
      description={
        "Help customers find your products on your storefront by sorting them under a group."
      }
      onClickClose={onClickClose}
    >
      <Link to={`${LAYOUT_GROUPING}?ungrouped=true`}>
        <Button color={"secondary"}>Organise</Button>
      </Link>
    </GroupProductsContainer>
  );
}
